import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-6">Terms of Service</h1>
        <p className="mb-4">
          Welcome to Payrendr! These Terms of Service govern your use of our website and services.
          By accessing or using our site, you agree to be bound by these terms.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
        <p className="mb-4">
          By using our services, you agree to these Terms of Service. If you do not agree with these terms,
          please do not use our website.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">2. Changes to Terms</h2>
        <p className="mb-4">
          We reserve the right to update or modify these terms at any time. Your continued use of our site following any changes
          will be deemed acceptance of those changes.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">3. Use of Service</h2>
        <p className="mb-4">
          You agree to use our services in compliance with all applicable laws and regulations. You must not misuse our services.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">4. Limitation of Liability</h2>
        <p className="mb-4">
          In no event shall Payrendr be liable for any damages arising out of the use or inability to use our services.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">5. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about these Terms, please contact us at <a href="mailto:support@payrendr.com" className="text-primary-600 hover:text-primary-700">support@payrendr.com</a>.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;